const IndexLeft = () =>import( '@/components/admin/IndexLeft')
// import IndexLeft from '@/components/admin/IndexLeft'
// import AdWebList from '@/components/admin/adweb/AdWebList'
const CardListView = () =>import( '@/components/admin/card/CardListView')
// import AdWebAdd from '@/components/admin/adweb/AdWebAdd'

export default
[{
    path: '/admin/card/list_view',
    name: 'CardListView',
    components: {indexLeft: IndexLeft, indexRight: CardListView}
  }
]



// WEBPACK FOOTER //
// ./src/router/cardRouter.js